import React from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { URLS } from "src/_config";
import { useTranslation } from "src/_common/hooks/useTranslation";

interface JobPostingThankYouProps {}

const JobPostingThankYou: React.FC<JobPostingThankYouProps> = () => {
  const history = useHistory();
  const { t } = useTranslation("job-create");
  const { jobType, jobId } = useParams<{ jobType: string; jobId?: string }>();

  const handleGotoTalentScouting = () => {
    if (jobId) {
      history.push(`/job-details/${jobId}`);
    }
  };

  return (
    <div className="job-posting-thank-you">
      <div className="thank-you-container">
        <div className="thank-you-content">
          {/* Success Icon */}
          <div className="success-icon">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" fill="#10B981" />
              <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          {/* Thank You Message */}
          <h1 className="thank-you-title">
            {jobType == "filter" ? t("jobCreate.thankYou.filter-title") : t("jobCreate.thankYou.title")}
          </h1>
          <p className="thank-you-subtitle">
            {jobType == "filter" ? t("jobCreate.thankYou.filter-subtitle") : t("jobCreate.thankYou.subtitle")}
          </p>

          {/* Job Status Info */}
          <div className="job-status-info">
            <div className="status-item">
              <div className="status-icon">
                <img src="/images/green-check.svg" alt="Published" width="20" height="20" />
              </div>
              <div className="status-text">
                <h4>{t("jobCreate.thankYou.status.published.title")}</h4>
                <p>
                  {jobType == "filter"
                    ? t("jobCreate.thankYou.status.published.filter-description")
                    : t("jobCreate.thankYou.status.published.description")}
                </p>
              </div>
            </div>
            <div className="status-item">
              <div className="status-icon">
                <img src="/images/cadidate-icon.svg" alt="Applications" width="20" height="20" />
              </div>
              <div className="status-text">
                <h4>{t("jobCreate.thankYou.status.readyForApplications.title")}</h4>
                <p>{t("jobCreate.thankYou.status.readyForApplications.description")}</p>
              </div>
            </div>
            <div className="status-item">
              <div className="status-icon">
                <img src="/images/notification-icon.svg" alt="Notifications" width="20" height="20" />
              </div>
              <div className="status-text">
                <h4>{t("jobCreate.thankYou.status.notificationsActive.title")}</h4>
                <p>{t("jobCreate.thankYou.status.notificationsActive.description")}</p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="thank-you-actions">
            <button className="btn-cancel" onClick={handleGotoTalentScouting}>
              {t("jobCreate.thankYou.buttons.gotoTalentScouting")}
            </button>
            {/* <Link to={URLS.JOB_POSTING.MY_JOBS || "/my-jobs"} className="btn-secondary">
              View My Jobs
            </Link> */}
            <Link to={jobType == "filter" ? URLS.JOB_POSTING.AI_CANDIDATE_SEARCH : URLS.JOB_POSTING.NEW}>
              <button className="btn-preview">
                {jobType == "filter"
                  ? t("jobCreate.thankYou.buttons.postAnotherFilter")
                  : t("jobCreate.thankYou.buttons.postAnotherJob")}
              </button>
            </Link>
          </div>

          {/* Next Steps */}
          {/* <div className="next-steps">
            <h3>What's Next?</h3>
            <ul>
              <li>Monitor applications in your dashboard</li>
              <li>Review candidate profiles and resumes</li>
              <li>Schedule interviews with qualified candidates</li>
              <li>Manage your job posting settings</li>
            </ul>
          </div> */}
        </div>

        {/* Additional Tips */}
        {/* <div className="tips-sidebar">
          <div className="tips-content">
            <h4>💡 Tips for Better Results</h4>
            <div className="tip-item">
              <h5>Optimize Your Job Title</h5>
              <p>Use clear, specific titles that candidates search for</p>
            </div>
            <div className="tip-item">
              <h5>Detailed Job Description</h5>
              <p>Include key responsibilities and requirements</p>
            </div>
            <div className="tip-item">
              <h5>Competitive Salary Range</h5>
              <p>Attract quality candidates with fair compensation</p>
            </div>
            <div className="tip-item">
              <h5>Quick Response</h5>
              <p>Respond to applications within 48 hours for best results</p>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default JobPostingThankYou;
